let initialized = false

async function initialize() {
  if (typeof document === "undefined") {
    return null
  }

  const loader = await import("@googlemaps/js-api-loader")

  if (!initialized) {
    loader.setOptions({
      key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "",
      v: "weekly",
    })

    initialized = true
  }

  return loader
}

export async function loadMapsLibrary() {
  const loader = await initialize()
  if (!loader) return null

  return loader.importLibrary("maps")
}

export async function loadPlacesLibrary() {
  const loader = await initialize()
  if (!loader) return null

  return loader.importLibrary("places")
}
